import { Injectable } from '@angular/core';
import { HttpService } from './http.service';

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  constructor(
    private http: HttpService
  ) { }

  checkUpdates() {
    return new Promise((resolve, reject) => {
      this.http.get('/apps/checkUpdate').subscribe((data) => {
        resolve(data || false);
      })
    });
  }

  loadMe() {
    return new Promise((resolve, reject) => {
      this._getMe().subscribe((data) => {
        resolve(data);
      });
    });
  }

  private _getMe() {
    return this.http.get('/users/me')
  }
}
